import React from 'react'

function CheckBox(props) {
    return (
        <>
            <input type="checkbox" value={props.value} id={props.id} checked={props.isChecked} onChange={props.handleCheckBox} />
            <label>&nbsp;&nbsp;{props.value}</label> <br />
        </>
    )
}

export default CheckBox
